"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THEME_NAME = void 0;
var THEME_NAME = 'button';
exports.THEME_NAME = THEME_NAME;
var _default = THEME_NAME;
exports.default = _default;